import ProgrammeImage1 from "../../../../../assets/images/png/courses/programme1.webp";
import ProgrammeImage2 from "../../../../../assets/images/png/courses/programme2.webp";
import ProgrammeImage3 from "../../../../../assets/images/png/courses/programme3.webp";
import SchoolImage from "../../../../../assets/images/png/school/programming-school.webp";

export const programmingSchoolDataAfrica = {
  tag: "Programming",
  id: "programmingSchool",
  url: "/programming-school",
  image: SchoolImage,

  name: "Programming school",
  description: `
  Go from zero knowledge to being able to build your own complete website! Starting with the foundations of software engineering. By the end of this program you would have mastered a specialization and learn the art of effective collaboration to solve real world problems.`,
  keywords: `Programming, programming school, coding, software engineer, software developer`,
  metatags: `Are you looking to learn programming or coding in Nigeria? Start your career in programming with courses from Utiva Programming School. Get the technical skills to get the job you want`,

  courses: [
    {
      id: 2,
      courseImage: ProgrammeImage3,
      courseName: "Become a Frontend Developer",
      courseDescription: `
        You’ll learn all you need to know and build the capacity to handle projects with an interesting portfolio as a frontend developer with a coaching program that focuses on fundamentals of HTML, CSS, JavaScript and React.
      `,
      courseStartDate: "December 2, 2023",

      courseDuration: "2 Months",

      courseTags: ["For Early Starters"],

      courseUrl: "/frontend-development",
    },
    {
      id: 3,
      courseImage: ProgrammeImage1,
      courseName: "Become a Backend Developer",
      courseDescription: `
        Go from zero knowledge to being able to build your own complete websites! Starting with the foundations of software engineering. Develop and deploy enterprise back-end applications following best practices using ExpresJS & NodeJS.
      `,
      courseStartDate: "December 2, 2023",

      courseDuration: "2 Months",

      courseTags: ["For Early Starters"],

      courseUrl: "/backend-development",
    },
    {
      id: 4,
      courseImage: ProgrammeImage2,
      courseName: "Become a Full-Stack Developer",
      courseDescription: `
        Go from zero knowledge to being able to build your technology platforms! Starting with the foundations of software engineering. By the end of this program you would have mastered a specialization and learn the art of effective collaboration to solve real world problems.
      `,
      courseStartDate: "December 2, 2023",

      courseDuration: "4 Months",

      courseTags: ["For Early Starters"],

      courseUrl: "/fullstack-development",
    },
  ],

  testimony: {
    testimonierImage: "",
    testimonierName: "",
    testimonierTitle: "",
    testimonyDescription: ``,
  },

  article: [],

  careerTitle: "Computer Programmer",

  careerPaths: [
    "Web Developer",
    "Front-End Developer",
    "Back-End Developer",
    "Full-Stack Developer ",
    "Game Developer",
    "Software Application Developer ",
    "Computer Systems Engineer ",
  ],

  quickFactSalary: "$85,000",

  quickFacts: [
    "Programming and coding has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum. computer programming and software engineering is one of the most high-profile jobs in the tech industry today. Companies are looking for software engineering talent - whether that's as a graduate or as a senior hire. ",
  ],
};
